import { render, staticRenderFns } from "./lock-modal-tips.vue?vue&type=template&id=214bf7aa&"
import script from "./lock-modal-tips.vue?vue&type=script&lang=ts&"
export * from "./lock-modal-tips.vue?vue&type=script&lang=ts&"
import style0 from "./lock-modal-tips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports